import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';


const Admin = () => {
    return (
        <AdminPanelSettingsIcon sx={{color:'#94A4C4'}}/>
    );
}; 
export default Admin;
